var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGastronomia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F05252"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6064 21.6759L18.5665 18.7158L11.2238 11.3835C9.59207 13.0152 9.59207 15.6615 11.2238 17.3037L15.6064 21.6759ZM22.6981 19.7827C24.2985 20.5253 26.5473 20.0023 28.2104 18.3392C30.2082 16.3414 30.5952 13.4755 29.0577 11.9379C27.5305 10.4108 24.6646 10.7873 22.6563 12.7851C20.9932 14.4482 20.4702 16.6971 21.2128 18.2974L11.0041 28.5061L12.479 29.9809L19.6857 22.7951L26.882 29.9914L28.3569 28.5166L21.1605 21.3203L22.6981 19.7827Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGastronomia);
export default __webpack_public_path__ + "static/media/gastronomia.19a928028a793123a06d3dc302c17601.svg";
export { ForwardRef as ReactComponent };